export default __webpack_public_path__ + "static/media/male-photo1.aa859487.jpg";